import { FC } from 'react'

import { useRouter } from 'next/navigation'
import styled from 'styled-components'

import {
  Txt,
  Card,
  CreateProjectIllustration,
  InvitationUserIllustration,
  DashboardCardBg,
} from 'src/components/atoms'
import { TransitionLinkTxt } from 'src/components/molecules'

import { Routes } from 'src/routes'

const Container = styled(Card)`
  width: 30.93rem;
  height: 26.93rem;
  transition: all 0.2s ease-in-out;
`

const Title = styled(Txt)`
  font-size: 1.71rem;
`

const StyledInvitationUserIllustration = styled(InvitationUserIllustration)`
  position: absolute;
  bottom: 3.29rem;
  left: 6.21rem;
  width: 15.57rem;
  z-index: 2;
`
const StyledCreateProjectIllustration = styled(CreateProjectIllustration)`
  position: absolute;
  bottom: 2.29rem;
  left: 6.86rem;
  width: 18.64rem;
  z-index: 2;
`
const StyledDashboardCardBg = styled(DashboardCardBg)`
  position: absolute;
  right: 0;
  top: 0;
  width: 23.57rem;
  aspect-ratio: 1;
`

export type InformationCardType = 'createProject' | 'inviteUser' | 'accessToCompass'

type Props = {
  type: InformationCardType
  className?: string
}

export const DashboardInformationCard: FC<Props> = ({ type, className }) => {
  const router = useRouter()

  const titleText =
    type === 'createProject'
      ? 'プロジェクトをつくろう'
      : type === 'inviteUser'
      ? 'ユーザーを招待する'
      : 'ROOV compassへアクセスしよう'
  const detailText =
    type === 'createProject'
      ? '販売開始前に新規プロジェクトを作ってROOV compassでの商談準備をしましょう。'
      : type === 'inviteUser'
      ? 'ユーザーをこのWORKSへ招待してプロジェクトにアサインするための準備をしましょう。'
      : 'アサインされたプロジェクトからROOV compassへアクセスできるようになります。プレゼンツールのセットアップをして商談の準備をしましょう。'
  const linkText =
    type === 'createProject' ? 'プロジェクト' : type === 'inviteUser' ? 'ユーザー' : 'プロジェクト'
  const handleOnClickTransitionLink = async () => {
    const to =
      type === 'createProject'
        ? Routes.ProjectTop.path
        : type === 'inviteUser'
        ? Routes.UserList.path
        : Routes.ProjectTop.path
    router.push(to)
  }

  return (
    <div className={className}>
      <Container
        padding="--s1 --s1 --s0"
        showShadow
        borderRadius="--s0"
        className="tw-flex tw-flex-col tw-justify-between tw-cursor-pointer tw-relative hover:tw-bg-surface-secondary"
        onClick={handleOnClickTransitionLink}
      >
        <div className="tw-text-roovPrimary-default">
          <Title className="tw-font-bold">{titleText}</Title>
          <Txt lineHeight="l" className="tw-mt-s0">
            {detailText}
          </Txt>
        </div>
        {type === 'createProject' || type === 'accessToCompass' ? (
          <StyledCreateProjectIllustration />
        ) : (
          <StyledInvitationUserIllustration />
        )}
        <StyledDashboardCardBg />
        <div>
          <TransitionLinkTxt text={linkText} className="tw-w-fit tw-ml-auto tw-mt-s1" />
        </div>
      </Container>
    </div>
  )
}
